export default {
  nav: {
    home: 'Home',
    spreadsheet: 'CSSBuy Spreadsheet',
    guides: 'Guides',
    review: 'Review',
    shipping: 'Shipping',
    qc: 'QC',
    warehouse: 'Warehouse',
    safety: 'Safety',
    faq: 'FAQ',
    shoppingGuide: 'Shopping Guide',
    categories: 'Categories',
    language: 'Language',
    pt: 'Português',
    de: 'Deutsch',
    en: 'English',
  },
  hero: {
    title: 'CSSBuy Spreadsheet: Find Products, Links and CSSBuy Guides in One Place',
    subtitle: 'Find and organize information about products, links, QC, shipping, warehouse and shopping with our independent CSSBuy Spreadsheet guide. Research better, compare options and make more informed decisions before buying.',
    ctaSpreadsheet: 'Explore CSSBuy Spreadsheet',
    ctaGuides: 'View CSSBuy Guides',
    ctaMain: 'Visit Main Website',
    ctaBuy: 'Buy It Now',
  },
  categories: {
    title: 'Explore Popular Categories',
    subtitle: 'Browse the most searched categories and find what you need faster.',
    dropdownLabel: 'Select a Category',
    dropdownPlaceholder: 'Choose category...',
    shoes: 'Shoes',
    hoodies: 'Hoodies / Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants / Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear / Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
    cta: 'View Spreadsheet →',
  },
  trust: {
    independent: 'Independent Guide',
    updated: 'Updated Content',
    multilingual: 'Multilingual',
    safety: 'Safety Focused',
  },
  whatIs: {
    title: 'What is a CSSBuy Spreadsheet?',
    intro: 'A CSSBuy Spreadsheet is an organization tool that gathers information about products, links, categories and CSSBuy-related resources. It helps buyers research, compare and find products more efficiently.',
    point1: 'Organize products by category for faster research',
    point2: 'Compare links and options before deciding',
    point3: 'Check QC, shipping and warehouse information',
    point4: 'Make more informed decisions with organized data',
    cta: 'Read Full Guide',
  },
  howItWorks: {
    title: 'How It Works',
    step1: 'Find',
    step1Desc: 'Browse categories and find relevant products in the spreadsheet.',
    step2: 'Compare',
    step2Desc: 'Compare links, prices and available options.',
    step3: 'Check QC',
    step3Desc: 'Review QC photos and ratings when available.',
    step4: 'Analyze Shipping',
    step4Desc: 'Understand shipping costs and options for your country.',
    step5: 'Decide',
    step5Desc: 'Make an informed decision with all information organized.',
  },
  guides: {
    title: 'Featured Guides',
    spreadsheetGuide: 'CSSBuy Spreadsheet Guide',
    spreadsheetGuideDesc: 'Learn how to use the CSSBuy Spreadsheet to research and organize products efficiently.',
    reviewGuide: 'CSSBuy Review 2026',
    reviewGuideDesc: 'Independent analysis of CSSBuy: features, shipping, warehouse and safety.',
    shippingGuide: 'CSSBuy Shipping Cost',
    shippingGuideDesc: 'Complete guide to shipping costs, options and calculations by country.',
    qcGuide: 'CSSBuy QC Guide',
    qcGuideDesc: 'How to interpret QC photos and verify product quality before shipping.',
    readMore: 'Read More',
  },
  pillars: {
    title: 'Pillar CSSBuy Articles',
    subtitle: 'Explore our complete guides on CSSBuy Spreadsheet, shipping, QC, safety, warehouse and more.',
    readMore: 'Read Article',
  },
  products: {
    title: 'Product Catalog',
    subtitle: 'Browse products from our partner store and find exactly what you\'re looking for.',
    buyNow: 'Buy Now',
    viewAll: 'View All',
  },
  cta: {
    title: 'CSSBuy Spreadsheet',
    subtitle: 'Visit our main website to explore the full CSSBuy Spreadsheet, find products and start shopping more safely.',
    buttonSpreadsheet: 'CSSBuy Spreadsheet',
    buttonBuy: 'Buy It Now',
    buttonVisit: 'Visit Main Website',
  },
  footer: {
    about: 'About',
    editorial: 'Editorial Policy',
    contact: 'Contact',
    privacy: 'Privacy',
    terms: 'Terms',
    disclaimer: 'This website is an independent informational resource and is not the official CSSBuy website. Information may change. Always verify current product, payment, shipping and account information through official channels before purchasing.',
    copyright: '© 2026 cssbuybr.tattoo — Independent CSSBuy Spreadsheet Guide',
    visitMain: 'Visit Main Website',
  },
  article: {
    title: 'CSSBuy Spreadsheet 2026: Complete Guide and Product Links',
    metaDesc: 'Complete CSSBuy Spreadsheet 2026 guide: what it is, how to use it, categories, QC, shipping and safety. Independent resource for confident product research.',
    breadcrumbHome: 'Home',
    breadcrumbArticle: 'CSSBuy Spreadsheet',
    updated: 'Updated on August 26, 2026',
    author: 'CSSBuy Spreadsheet Editorial Team',
    reviewed: 'Reviewed by international shopping experts',
    quickAnswer: 'The CSSBuy Spreadsheet is an organization tool that gathers information about products, links and resources related to CSSBuy. It helps buyers research, compare and find products more efficiently by organizing data by category and providing quick access to QC, shipping and warehouse information.',
    h1: 'CSSBuy Spreadsheet 2026: Complete Guide and Product Links',
    h2What: 'What is the CSSBuy Spreadsheet?',
    h2WhatP1: 'The CSSBuy Spreadsheet is an organizational resource developed to help buyers navigate the vast product catalog available through CSSBuy. It works as a structured directory where information about products, links, categories and resources is compiled systematically.',
    h2WhatP2: 'Unlike a simple list of links, a well-organized spreadsheet allows you to filter by category, compare options and access specific guides for each product type. This is especially useful for those starting to explore international shopping and need a reliable starting point.',
    h2How: 'How to Use the CSSBuy Spreadsheet',
    h2HowP1: 'Using the CSSBuy Spreadsheet is a simple process that can transform your research experience. First, identify the product category you are looking for — whether shoes, clothing, accessories or electronics. Navigate to that category in the spreadsheet and explore the available options.',
    h2HowP2: 'When you find an interesting product, check the QC (Quality Control) information when available. QC photos are essential to assess the actual quality of the item before making a purchase. Also pay attention to shipping and warehouse information to understand total costs and delivery time.',
    h2Categories: 'CSSBuy Spreadsheet Categories',
    h2CategoriesP1: 'The CSSBuy Spreadsheet organizes products into clear, intuitive categories. The main categories include:',
    catShoes: 'Shoes and Sneakers — from casual models to limited editions',
    catHoodies: 'Hoodies and Sweaters — winter clothing and streetwear pieces',
    catTshirts: 'T-Shirts — basics, printed and special editions',
    catJackets: 'Jackets — coats, parkas and windbreakers',
    catPants: 'Pants and Shorts — jeans, cargo, sporty and casual',
    catAccessories: 'Accessories — belts, glasses, jewelry and assorted items',
    catBags: 'Bags — backpacks, wallets, travel bags',
    catPerfumes: 'Perfumes — fragrances and personal care products',
    h2Qc: 'CSSBuy QC: Quality Control and Photos',
    h2QcP1: 'QC (Quality Control) is one of the most important features of CSSBuy. When you purchase a product, the agent can take detailed photos of the item before shipping it to you. This allows you to verify the quality, color, size and actual finish of the product.',
    h2QcP2: 'QC photos are particularly valuable for products where details matter, such as shoes, brand clothing and accessories. Whenever possible, request QC photos and compare them with the original seller images to identify discrepancies.',
    h2Shipping: 'CSSBuy Shipping Cost: Shipping Costs',
    h2ShippingP1: 'CSSBuy shipping cost depends on several factors: destination country, package weight, dimensions, chosen shipping method and whether you opt for additional services such as insurance or reinforced packaging. Countries like the United States, United Kingdom, Germany and Brazil have different options with varying costs.',
    h2ShippingP2: 'Before finalizing a purchase, it is essential to calculate the total cost including the product, agent fees, shipping and possible import taxes. Use the spreadsheet to compare different scenarios and choose the most economical option for your situation.',
    h2Safety: 'CSSBuy Safety: Security and Precautions',
    h2SafetyP1: 'Safety is a priority when using any international shopping service. Always verify you are on the correct website, never share your password, confirm prices before paying and check QC photos when available.',
    h2SafetyP2: 'This spreadsheet is an independent informational resource. It does not guarantee product quality, is not an official certification and does not replace your own research. Always verify updated information through official channels before making purchases.',
    h2Table: 'CSSBuy Spreadsheet vs Normal Search',
    feature: 'Feature',
    spreadsheet: 'CSSBuy Spreadsheet',
    normalSearch: 'Normal Search',
    prodDiscovery: 'Product Discovery',
    prodDiscoveryS: 'Easy and organized',
    prodDiscoveryN: 'Medium',
    organization: 'Organization',
    organizationS: 'High',
    organizationN: 'Low',
    categorySearch: 'Category Search',
    categorySearchS: 'Yes',
    categorySearchN: 'Variable',
    qcRef: 'QC Reference',
    qcRefS: 'Available when provided',
    qcRefN: 'Variable',
    beginnerFriendly: 'Beginner Friendly',
    beginnerFriendlyS: 'High',
    beginnerFriendlyN: 'Medium',
    h2Faq: 'Frequently Asked Questions (FAQ)',
    faq1Q: 'Is the CSSBuy Spreadsheet official?',
    faq1A: 'No. This is an independent informational resource. We are not official CSSBuy affiliates and do not represent the company. Our goal is to provide guides and information organization to help with your research.',
    faq2Q: 'How do I access the CSSBuy Spreadsheet?',
    faq2A: 'You can access the CSSBuy Spreadsheet through our main website. Browse categories, explore products and follow the links for more information.',
    faq3Q: 'Does the spreadsheet guarantee product quality?',
    faq3A: 'No. The spreadsheet organizes information but does not guarantee quality, authenticity or availability. Always verify QC photos, prices and shipping information before purchasing.',
    faq4Q: 'What categories are available?',
    faq4A: 'Categories include shoes, hoodies, t-shirts, jackets, pants, bags, accessories, perfumes, belts, headwear, sets, underwear, jersey and other products.',
    faq5Q: 'Is CSSBuy safe?',
    faq5A: 'CSSBuy is a known platform, but like any online service, it requires caution. Verify URLs, protect your account, confirm prices and use QC photos to verify products.',
    ctaMain: 'Visit Main Website',
    ctaSpreadsheet: 'Explore CSSBuy Spreadsheet',
    ctaSafety: 'Read Safety Guide',
    tipLabel: 'CSSBuy Spreadsheet Tip',
    tipText: 'Use the spreadsheet to compare multiple products before deciding. Cross-reference QC photos, shipping costs and seller information for the best experience.',
    bottomCtaText: 'Explore the CSSBuy Spreadsheet on the main website and find the products you are looking for.',
    sidebarCtaText: 'Access the complete spreadsheet on the main website.',
    sidebarCategories: 'Categories',
    toc: 'Contents',
    tocWhat: 'What is it?',
    tocHow: 'How to use',
    tocCategories: 'Categories',
    tocQc: 'QC and Photos',
    tocShipping: 'Shipping Cost',
    tocSafety: 'Safety',
    tocTable: 'Comparison',
    tocFaq: 'FAQ',
  },
  notFound: {
    message: 'Page not found. Go back to the homepage and explore the CSSBuy Spreadsheet.',
  },
};